var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"social"}},[_c('v-container',{attrs:{"grid-list-xl":"","fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"lg7":"","sm12":"","xs12":""}},[_c('plain-table')],1),_c('v-flex',{attrs:{"lg5":"","sm12":"","xs12":""}},[_c('plain-table-order')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }